(ns ui.view.card.counterparty-diligence-docs.sub
  (:require
   [re-frame.core :as rf]
   [ui.view.card.sub :as common-sub]
   [common.util :as cu]))

(rf/reg-sub
 ::counterparty-diligence
 (fn [[_ ctx]]
   [(rf/subscribe [::common-sub/entities ctx])])
 (fn [[entities] [_ {:keys [entity-id]}]]
   (get entities entity-id)))

(rf/reg-sub
 ::process-ids
 (fn [[_ ctx]]
   [(rf/subscribe [::counterparty-diligence ctx])])
 (fn [[counterparty-diligence]]
   (:counterparty-diligence/processes counterparty-diligence)))

(rf/reg-sub
 ::processes
 (fn [[_ ctx]]
   [(rf/subscribe [::process-ids ctx])
    (rf/subscribe [::common-sub/entities ctx])])
 (fn [[process-ids entities]]
   (->> process-ids
        (mapv (fn [id]
                (get entities id)))
        (filterv boolean))))

(rf/reg-sub
 ::latest-process
 (fn [[_ ctx]]
   [(rf/subscribe [::processes ctx])])
 (fn [[processes]]
   (->> processes
        (sort-by :common/created-on)
        last)))

(rf/reg-sub
 ::latest-process-answers
 (fn [[_ ctx]]
   [(rf/subscribe [::latest-process ctx])])
 (fn [[latest-process]]
   (or (:counterparty-diligence-process/answers latest-process)
       {})))

(rf/reg-sub
 ::status
 (fn [[_ ctx]]
   [(rf/subscribe [::counterparty-diligence ctx])])
 (fn [[counterparty-diligence]]
   (:counterparty-diligence/status counterparty-diligence)))

(rf/reg-sub
 ::e-signature-required?
 (fn [[_ ctx]]
   [(rf/subscribe [::counterparty-diligence ctx])])
 (fn [[counterparty-diligence]]
   (-> counterparty-diligence
       :counterparty-diligence/e-signature-required
       (= :yes))))

(rf/reg-sub
 ::esign-process
 (fn [[_ ctx]]
   [(rf/subscribe [::latest-process ctx])
    (rf/subscribe [::common-sub/entities ctx])])
 (fn [[latest-process card-entities-by-id]]
   (when-let [latest-process-id (:db/id latest-process)]
     (->> card-entities-by-id
          vals
          (filterv (fn [{:keys [esign-process/target]}]
                     (= target latest-process-id)))
          (sort-by :common/created-on)
          last))))

(rf/reg-sub
 ::signatories
 (fn [[_ ctx]]
   [(rf/subscribe [::esign-process ctx])
    (rf/subscribe [::latest-process-answers ctx])
    (rf/subscribe [::common-sub/entities ctx])])
 (fn [[esign-process latest-process-answers entities-by-id]]
   (if esign-process
     (->> esign-process
          :esign-process/signatories
          (mapv #(get entities-by-id %)))
     (->> latest-process-answers
          :signatories
          (filterv (fn [{:keys [full-name email]}]
                     (or (seq full-name)
                         (seq email))))
          (map-indexed
           (fn [idx {:keys [full-name email]}]
             {:db/id (str "temp-signatory-" full-name "-" email "-" idx)
              :signatory/name full-name
              :signatory/email email
              :signatory/sign-status :signatory.sign-status/not-sent}))
          vec))))

(rf/reg-sub
 ::esigned-answers-document
 (fn [[_ ctx]]
   [(rf/subscribe [::esign-process ctx])
    (rf/subscribe [::common-sub/entities ctx])])
 (fn [[esign-process card-entities-by-id]]
   (when esign-process
     (->> esign-process
          :common/attachments
          (mapv #(get card-entities-by-id %))
          (filterv (fn [{:keys [common/system-kws]}]
                     (some (set system-kws) [:esign-attachment/signed])))
          (sort-by :common/created-on)
          last))))
